// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"01077020","239":"40ed4e19","732":"85cff99e"}[chunkId] + ".chunk.js";
};